/* unplugin-vue-components disabled */import { render } from "./PluginItem.vue?vue&type=template&id=2289f20c&scoped=true&ts=true"
import script from "./PluginItem.vue?vue&type=script&lang=ts"
export * from "./PluginItem.vue?vue&type=script&lang=ts"

import "./PluginItem.vue?vue&type=style&index=0&id=2289f20c&lang=scss&scoped=true"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2289f20c"]])

export default __exports__